const mall = [
  {
    name: "星巴克",
    id: 0,
    center: [121.507168, 31.240737],
    bounds: [
      [121.507209, 31.240591],
      [121.507168, 31.240737],
      [121.506789, 31.240712],
      [121.506928, 31.240469],
    ],
    car: [
      521,
      186,
      96,
      6,
      26,
      252,
      925,
      976,
      1143,
      1104,
      981,
      863,
      733,
      1032,
      623,
      823,
      834,
      1225,
      1398,
      1325,
      932,
      734,
      682,
      321,
    ],
    customer: [
      92,
      72,
      24,
      14,
      0,
      33,
      57,
      96,
      163,
      153,
      125,
      163,
      243,
      184,
      105,
      163,
      121,
      241,
      263,
      133,
      184,
      163,
      153,
      73,
    ],
  },
  {
    name: "正大百货",
    id: 1,
    center: [121.505534, 31.242951],
    bounds: [
      [121.504842, 31.242589],
      [121.506503, 31.243353],
      [121.507033, 31.242682],
      [121.505246, 31.242018],
    ],
    car: [
      750,
      320,
      83,
      13,
      47,
      627,
      834,
      1242,
      1463,
      1282,
      1136,
      1127,
      941,
      993,
      864,
      934,
      1123,
      1337,
      1574,
      1434,
      1179,
      953,
      833,
      642,
    ],
    customer: [
      524,
      73,
      79,
      68,
      43,
      242,
      517,
      825,
      823,
      817,
      251,
      652,
      664,
      602,
      173,
      434,
      113,
      737,
      852,
      849,
      812,
      564,
      203,
      303,
    ],
  },
  {
    name: "星期五餐厅",
    id: 2,
    center: [121.504534, 31.241951],
    bounds: [
      [121.504534, 31.241951],
      [121.504161, 31.241816],
      [121.504404, 31.241554],
      [121.504615, 31.24165],
    ],
    car: [
      123,
      89,
      14,
      0,
      3,
      132,
      251,
      473,
      896,
      924,
      997,
      734,
      1155,
      1021,
      513,
      423,
      704,
      1078,
      1189,
      1023,
      743,
      521,
      325,
      253,
    ],
    customer: [
      67,
      38,
      13,
      13,
      0,
      76,
      124,
      193,
      238,
      164,
      114,
      210,
      286,
      275,
      98,
      121,
      93,
      295,
      244,
      179,
      146,
      174,
      123,
      121,
    ],
  },
]
var professionData = [
  [
    {
      value: 0,
      name: "男",
    },
    {
      value: 0,
      name: "女",
    },
  ],
  [
    {
      value: 0,
      name: "司机",
    },
    {
      value: 0,
      name: "高净值人群",
    },
    {
      value: 0,
      name: "白领",
    },
    {
      value: 0,
      name: "自有职业者",
    },
    {
      value: 0,
      name: "事业单位职员",
    },
    {
      value: 0,
      name: "其他行业",
    },
    // {
    //   value: 0,
    //   name: "其它",
    // },
    // {
    //   value: 0,
    //   name: "事业单位职员",
    // },
  ],
]
var sum = 0
mall.forEach((d) => {
  d.car.forEach((c) => {
    sum += c
  })
})

var bi = [0.36, 0.03, 0.44, 0.05, 0.08, 0.04]
var ts = professionData[1]
for (let i = ts.length - 1; i >= 0; i--) {
  ts[i].value = Math.round(sum * bi[i])
}
professionData[0][0] = Math.round(sum * 0.672)
professionData[0][1] = Math.round(sum * 0.328)

export { mall, professionData }
